// extracted by mini-css-extract-plugin
module.exports = {"container":"FollowUp_container__354W7"};